import { readActiveMissionId } from '../content-director-store'
import { readMissionStoreByMissionId } from '../../lesson-content/lesson-content-store'

function getActiveMission() {
  const activeMissionId = readActiveMissionId()
  return readMissionStoreByMissionId(activeMissionId)
}

export { getActiveMission }